export default __webpack_public_path__ + "static/banner2-bg-a6f67efb4e675179a0e765a99bb8f6b3.jpg";